import React from 'react';
import SvgIcon from "../svg-icon/SvgIcon";

export const InfoIcon = (props) => {
  return (
      <SvgIcon {...props} viewBox="0 0 61 61" fontSize="xxxLarge">
          <defs>
              <style>
                  {`.a{fill:#fff;stroke-width:2px;}.a,.b{stroke:#369aff}.b,.d{fill:none;}.b{stroke-width:3.5px;}.c{stroke:none;}`}
              </style>
          </defs>

          <g transform="translate(-532 -1634)">
              <g transform="translate(143 649)">
                  <g className="a" transform="translate(389 985)">
                      <circle className="c" cx="30.5" cy="30.5" r="30.5"/>
                      <circle className="d" cx="30.5" cy="30.5" r="29.5"/>
                  </g>
              </g>
              <line className="b" y2="21" transform="translate(562.5 1677.5) rotate(180)"/>
              <line className="b" y2="3" transform="translate(562.5 1653.5) rotate(180)"/>
          </g>
      </SvgIcon>
  );
};

InfoIcon.propTypes = {}

InfoIcon.defaultProps = {}

export default InfoIcon;
